export type GamePreviewMode = "desktop" | "mobile";

/** iPhone SE — ขนาดพื้นที่ iframe โหมด mobile */
export const MOBILE_PREVIEW_WIDTH = 375;
export const MOBILE_PREVIEW_HEIGHT = 667;
